import {
    SHOW_MULTI_PDP_VISITS,
    SHOW_PDP_SOURCING,
    PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP,
    NOTIFICATION_KEYS as SHARED_NOTIFICATION_KEYS,
} from '../pdp/PdpSharedNotifications/pdpSharedNotificationConstants';

export function pdpRespNotificationsReducer(state, action) {
    switch (action.type) {
        case SHOW_MULTI_PDP_VISITS:
            return {
                ...state,
                notifications: { [SHARED_NOTIFICATION_KEYS.MULTI_PDP_VISITS]: true },
            };
        case SHOW_PDP_SOURCING:
            return {
                ...state,
                notifications: { [SHARED_NOTIFICATION_KEYS.PDP_SOURCING_MODAL]: true },
            };
        case PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP:
            return {
                ...state,
                notifications: {
                    [SHARED_NOTIFICATION_KEYS.PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP]: true,
                },
            };
        default:
            return state || { notifications: {} };
    }
}
